import React from "react";
import PropTypes from "prop-types";
import SimpleButton from "./simple-button";
import { injectIntl } from "react-intl";

const SearchClearButton = ({ className, onClick, intl }) => (
  <SimpleButton className={className} onClick={onClick} label={intl.formatMessage({ id: "common.delete" })} />
);

SearchClearButton.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Función que se invoca al hacer clic
   */
  onClick: PropTypes.func,
};

export default injectIntl(SearchClearButton);
